/* Mega menú TopMovil · tm_mega_menu_v1_2026-08-27
   Abre por hover con intención en escritorio (puntero fino), como las tiendas grandes;
   clic, teclado y foco siguen siendo los de Dawn (header-menu / DetailsDisclosure).
   Un solo panel abierto a la vez; ESC cierra. */
(function () {
  'use strict';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var OPEN_DELAY = 70, CLOSE_DELAY = 160;

  function setup(menu) {
    var details = menu.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    var openT = null, closeT = null;

    function open() {
      clearTimeout(closeT);
      if (details.open) return;
      document.querySelectorAll('.tm-mega header-menu details[open]').forEach(function (d) {
        if (d !== details) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }
      });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
    function close() {
      clearTimeout(openT);
      if (!details.open) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }

    menu.addEventListener('mouseenter', function () {
      if (!fine.matches) return;
      clearTimeout(closeT);
      openT = setTimeout(open, OPEN_DELAY);
    });
    menu.addEventListener('mouseleave', function () {
      if (!fine.matches) return;
      clearTimeout(openT);
      closeT = setTimeout(close, CLOSE_DELAY);
    });
    // Con hover ya abierto, el clic en el título navega... no hay URL en <summary>: lo dejamos alternar (Dawn).
  }

  function init() {
    var nav = document.querySelector('.tm-mega');
    if (!nav) return;
    nav.querySelectorAll('header-menu').forEach(setup);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      nav.querySelectorAll('header-menu details[open]').forEach(function (d) {
        d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) { s.setAttribute('aria-expanded', 'false'); s.focus(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
